import type { BrowserTranslations } from '../i18n';

export const operationTranslations: BrowserTranslations = Object.freeze({
  'Checking the edit result': [
    'Comprobando el resultado de la edición', 'Vérification du résultat de la modification', 'Ergebnis der Bearbeitung wird geprüft',
    'Verificando o resultado da edição', '正在检查编辑结果', '編集結果を確認しています', '편집 결과를 확인하는 중',
  ],
  'The edit result is unknown. Editing, opening and saving are paused until recovery completes.': [
    'Se desconoce el resultado de la edición. La edición, la apertura y el guardado están en pausa hasta que termine la recuperación.',
    'Le résultat de la modification est inconnu. La modification, l’ouverture et l’enregistrement sont suspendus jusqu’à la fin de la récupération.',
    'Das Ergebnis der Bearbeitung ist unbekannt. Bearbeiten, Öffnen und Speichern sind bis zum Abschluss der Wiederherstellung pausiert.',
    'O resultado da edição é desconhecido. A edição, a abertura e o salvamento estão pausados até a recuperação terminar.',
    '编辑结果未知。恢复完成前，编辑、打开和保存操作已暂停。',
    '編集結果を確認できません。復旧が完了するまで、編集、ファイルの読み込み、保存は一時停止されます。',
    '편집 결과를 확인할 수 없습니다. 복구가 완료될 때까지 편집, 열기 및 저장이 일시 중지됩니다.',
  ],
  'Retry edit recovery': [
    'Reintentar la recuperación de la edición', 'Réessayer la récupération de la modification', 'Wiederherstellung der Bearbeitung erneut versuchen',
    'Tentar recuperar a edição novamente', '重试编辑恢复', '編集の復旧を再試行', '편집 복구 다시 시도',
  ],
  'The edit is committed. Restore graphics to continue.': [
    'La edición se ha confirmado. Restaura los gráficos para continuar.',
    'La modification est validée. Restaurez le rendu graphique pour continuer.',
    'Die Bearbeitung wurde übernommen. Stellen Sie die Grafik wieder her, um fortzufahren.',
    'A edição foi confirmada. Restaure os gráficos para continuar.',
    '编辑已提交。请恢复图形以继续。', '編集は確定されています。続行するにはグラフィックスを復元してください。',
    '편집이 확정되었습니다. 계속하려면 그래픽을 복원하세요.',
  ],
});
